module.exports = require('./dist/package/gdal3.node.js');
